import FullPageSuccess from 'components/FullPageSuccess';
import {
  LP_CAPITAL_ACTION_CREATE,
  LP_REALISATION_CREATE,
} from 'adminConstants/routes';

const SuccessPage: React.FC = () => {
  return (
    <FullPageSuccess
      title="Your realisation has been processed successfully"
      additionalText={
        'The General Ledger has been updated and any cash consideration from this realisation will be available to distribute in your next capital action.'
      }
      proceedText="Process capital action"
      proceedLink={LP_CAPITAL_ACTION_CREATE}
      tertiaryText="Add another realisation"
      tertiaryLink={LP_REALISATION_CREATE}
    />
  );
};

export default SuccessPage;
